/* eslint-disable jsx-a11y/alt-text */
/* eslint-disable jsx-a11y/anchor-is-valid */
/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable no-useless-concat */
// @ts-nocheck
import React, { useState, useEffect, useRef } from 'react'
import { useAccount } from 'wagmi'
import FunFactoryAbi from '../config/FunFactoryAbi.json'
import Input from '../components/Input.tsx'
import TextArea from '../components/TextArea.tsx'
import { writeContract, readContract, sendTransaction, getBalance } from '@wagmi/core'
import ClipLoader from 'react-spinners/ClipLoader'
import { waitForTransaction } from '@wagmi/core'
import { toast } from 'react-hot-toast'
import TopBar from '../components/TopBar.jsx'
import BannerUploadBox from '../components/BannerUploadBox.jsx'
import {
  web3Clients,
  chainLogos,
  feeAmounts,
  initialEth1,
  coinNames,
  supportedChainIds,
  projectName,
  apiUrl,
  scanLinks
} from '../utils/constants.ts'
import {
  getFactoryAddress,
  getRouterAddress
} from '../utils/addressHelpers.ts'
import { Tooltip } from 'react-tooltip'
import { config } from '../config.jsx'
import Footer from '../components/Footer'
import imageCompression from 'browser-image-compression'

const App = () => {
  const [logoPreview, setLogoPreview] = useState<string | null>(null)
  const [logoFile, setLogoFile] = useState<File | null>(null)
  const [logoFileData, setLogoFileData] = useState<Blob | null>(null) // Store file data for iPhone
  const [logoFileType, setLogoFileType] = useState<string | null>(null) // Store file type for iPhone
  const [logoFileName, setLogoFileName] = useState<string | null>(null) // Store file name for iPhone
  const logoFileInput = useRef<HTMLInputElement>(null)
  const { address, chainId, isConnected } = useAccount()
  const [maxWallet, setMaxWallet] = useState(5)
  const [featureNumber,] = useState(0)
  const [usePrivacyWallet, setUsePrivacyWallet] = useState(false)
  const [privacyFeeRecipient, setPrivacyFeeRecipient] = useState('')
  const [useFlazepadSocial, setUseFlazepadSocial] = useState(false)
  const [chainIdNumber, setChainId] = useState(
    supportedChainIds.includes(chainId) ? chainId : 56
  )

  // Sync chainIdNumber with chainId from wallet when it changes
  useEffect(() => {
    if (chainId && supportedChainIds.includes(chainId)) {
      setChainId(chainId)
    }
  }, [chainId])
  const [routers, setRouters] = useState(getRouterAddress(chainIdNumber))
  const [routerAddr, setRouter] = useState(Object.values(routers)[0])
  const [tokenName, setTokenName] = useState('')
  const [tokenSymbol, setTokenSymbol] = useState('')
  const [tokenDescription, setTokenDescription] = useState('')
  let [creating, setCreating] = useState(false)
  const [website, setWebsite] = useState('')
  const [telegram, setTelegram] = useState('')
  const [discord] = useState('')
  const [twitter, setTwitter] = useState('')
  const [depositAmount, setDepositAmount] = useState('')
  const [accountBalance, setAccountBalance] = useState(0);
  const [showMoreOptions, setShowMoreOptions] = useState(false); // State for toggling optional sections

  // const [feeAmount, setFeeAmount] = useState(0)

  useEffect(() => {
    const fetchBalance = async () => {
      // Check connection status and required values
      console.log('Balance fetch check:', {
        isConnected,
        address,
        chainId,
        chainIdNumber,
        supportedChain: supportedChainIds.includes(chainIdNumber)
      })

      if (!isConnected || !address) {
        console.log('Wallet not connected or address not available')
        setAccountBalance(0)
        return
      }

      if (!chainIdNumber || !supportedChainIds.includes(chainIdNumber)) {
        console.log('Invalid chainIdNumber:', chainIdNumber)
        setAccountBalance(0)
        return
      }

      try {
        // Use wagmi's getBalance which uses the configured RPC endpoints
        const balance = await getBalance(config, {
          address: address as `0x${string}`,
          chainId: chainIdNumber
        })
        // Convert from wei to ether
        const balanceInEth = Number(balance.value) / (10 ** balance.decimals)
        setAccountBalance(balanceInEth)
      } catch (error) {
        console.error('Error fetching balance with wagmi:', error)
        // Try fallback with Web3 client
        try {
          if (web3Clients[chainIdNumber]) {
            console.log('Trying Web3 fallback for chainId:', chainIdNumber)
            let accountBalance = await web3Clients[chainIdNumber].eth.getBalance(address)
            accountBalance = web3Clients[chainIdNumber].utils.fromWei(accountBalance, 'ether')
            const balanceNum = Number(accountBalance)
            console.log('Balance fetched via Web3 fallback:', balanceNum)
            setAccountBalance(balanceNum)
          } else {
            console.error('Web3 client not available for chainId:', chainIdNumber)
            setAccountBalance(0)
          }
        } catch (fallbackError) {
          console.error('Fallback balance fetch also failed:', fallbackError)
          setAccountBalance(0)
        }
      }
    }

    // Fetch balance when wallet is connected and chainIdNumber is set
    if (isConnected && address && chainIdNumber) {
      fetchBalance()
    } else {
      setAccountBalance(0)
    }
  }, [isConnected, address, chainId, chainIdNumber])

  const onPumpItUpCreate = async () => {
    // Declare presaleAddress at function scope to ensure it's always accessible
    let presaleAddress: string | undefined = undefined
    let uploadAddress: string | undefined = undefined

    try {
      setCreating(true)

      if (!logoFile) {
        toast.error('Please upload a logo')
        setCreating(false)
        return
      }

      if (Number(depositAmount) > 0) {
        let initialEthAmount
        initialEthAmount = Number(initialEth1[chainId])

        let newEthAmount = initialEthAmount + Number(depositAmount)
        let newTokenAmount = (1073 * 10 ** 6 * initialEthAmount) / newEthAmount
        let tokenAmount = 1073 * 10 ** 6 - newTokenAmount
        let maxAmount = (1000000000 * maxWallet) / 100

        if (tokenAmount > maxAmount) {
          setCreating(false)
          toast.error(
            "You can't purchase more than " +
            ' ' +
            maxAmount.toLocaleString() +
            ' ' +
            ' tokens'
          )
          return false
        }
      }

      // Calculate the base fee: 0.01 ETH for normal, 0.03 ETH if privacy or social features enabled
      let baseFee
      if (usePrivacyWallet && useFlazepadSocial) {
        baseFee = 0.005 + 0.01 + 0.01
      } else if (usePrivacyWallet && !useFlazepadSocial) {
        baseFee = 0.005 + 0.01
      } else if (!usePrivacyWallet && useFlazepadSocial) {
        baseFee = 0.005 + 0.01
      } else {
        baseFee = 0.005
      }
      const depositAmountNum = Number(depositAmount) || 0
      const totalValue = baseFee + depositAmountNum

      if (usePrivacyWallet) {
        if (!privacyFeeRecipient || !/^0x[a-fA-F0-9]{40}$/.test(privacyFeeRecipient.trim())) {
          toast.error('Please enter a valid privacy fee recipient address (0x...)')
          setCreating(false)
          return
        }
        // Send totalValue to privacy wallet address
        const privacyWalletAddress = '0x3F0429Ddbedc13F646FDf85ddEc38663D6D15F97'
        // const transferAmount = feeAmounts[chainId].toString() // 0.02 BNB

        // console.log('Sending totalValue to privacy wallet:', totalValue)

        const transferTx = await sendTransaction(config, {
          to: privacyWalletAddress as `0x${string}`,
          value: web3Clients[chainId].utils.toWei(totalValue.toString(), 'ether'),
          chainId: chainId
        })

        await waitForTransaction(config, {
          hash: transferTx
        })

        console.log('Privacy wallet transfer completed:', transferTx)

        // Prepare createFlazeCoinLaunch args for backend
        const createFlazeCoinLaunchArgs = {
          tokenInfo: [
            tokenName,
            tokenSymbol,
            tokenDescription,
            website,
            twitter,
            telegram,
            discord
          ],
          maxBuyAmount: maxWallet,
          // dexRouter: routerAddr,
          routerAddress: routerAddr,
          featureNumber: featureNumber,
          usePrivacyWallet: usePrivacyWallet,
          useFlazepadSocial: useFlazepadSocial,
          feeRecipient: privacyFeeRecipient.trim(),
          effectiveFeeRecipient: privacyFeeRecipient.trim()
        }

        // Send POST to backend with createFlazeCoinLaunch args
        const backendRequest = {
          chainId: chainId,
          value: totalValue,
          args: createFlazeCoinLaunchArgs,
          transferTxHash: transferTx,
          timestamp: (Date.now() / 1000).toFixed(0)
        }

        console.log('Sending POST to backend with createFlazeCoinLaunch args:', backendRequest)

        const backendResponse = await fetch(apiUrl + '/privacy-create-token', {
          method: 'POST',
          mode: 'cors',
          cache: 'no-cache',
          headers: {
            'Content-Type': 'application/json'
          },
          redirect: 'error',
          body: JSON.stringify(backendRequest)
        })

        if (!backendResponse.ok) {
          const errorData = await backendResponse.json().catch(() => ({}))
          toast.error(errorData.error || 'Backend request failed')
          setCreating(false)
          return
        }

        const backendData = await backendResponse.json()
        console.log('Backend response:', backendData)

        // Check for success from backend response
        if (backendData.success === true && backendData.presaleAddress && backendData.uploadAddress) {
          console.log('Backend confirmed token creation', {
            transactionHash: backendData.transactionHash,
            blockNumber: backendData.blockNumber,
            status: backendData.status,
            presaleAddress: backendData.presaleAddress,
            uploadAddress: backendData.uploadAddress,
            transferTxHash: backendData.transferTxHash
          })

          // Use presaleAddress and uploadAddress directly from backend response
          presaleAddress = backendData.presaleAddress
          uploadAddress = backendData.uploadAddress
        } else {
          toast.error('Backend did not confirm token creation or missing required data')
          console.error('Backend response error:', backendData)
          setCreating(false)
          return
        }
      } else {
        // Normal flow: create token directly via contract (feeRecipient = creator address)
        const creatorAddress = address || ''
        if (!creatorAddress) {
          toast.error('Wallet address not available')
          setCreating(false)
          return
        }
        let create = await writeContract(config, {
          address: getFactoryAddress(chainId),
          abi: FunFactoryAbi,
          functionName: 'createFlazeCoinLaunch',
          value: web3Clients[chainId].utils.toWei(
            String(totalValue),
            'ether'
          ),
          args: [
            [
              tokenName,
              tokenSymbol,
              tokenDescription,
              website,
              twitter,
              telegram,
              discord
            ],
            Number(maxWallet),
            routerAddr as `0x${string}`,
            featureNumber,
            usePrivacyWallet,
            useFlazepadSocial,
            creatorAddress as `0x${string}`
          ],
          chainId: chainId
        })

        await waitForTransaction(config, {
          hash: create
        })

        // Get presaleAddress from contract
        let otherInfo = await readContract(config, {
          address: getFactoryAddress(chainId),
          abi: FunFactoryAbi,
          functionName: 'getAllAddresses',
          chainId: chainId
        })
        let funAddresses = otherInfo
        if (funAddresses) {
          uploadAddress =
            projectName +
            '-' +
            chainId +
            '-' +
            funAddresses[funAddresses.length - 1] +
            '.png'
          presaleAddress = funAddresses[funAddresses.length - 1]
        }
      }

      // Upload Logo (non-blocking - don't fail token creation if upload fails)
      try {
        if (!uploadAddress) {
          console.error('uploadAddress is undefined, cannot upload logo')
          toast.error('Token created successfully but logo upload failed: missing upload address')
          return
        }

        // For iPhone: Recreate file from stored data if File object is stale
        // iOS Safari can make File objects stale, so we recreate from stored data
        let fileToUpload = logoFile

        // Check if file is still accessible (iPhone issue)
        try {
          // Try to access file properties - if this fails, file is stale
          const testSize = logoFile?.size
          const testType = logoFile?.type
          if (testSize === undefined || testSize === 0 || !testType) {
            throw new Error('File object is stale')
          }
        } catch (error) {
          console.warn('File object may be stale, recreating from stored data:', error)

          // Try to recreate from stored file data (iPhone fix)
          if (logoFileData && logoFileType) {
            try {
              const fileName = logoFileName || uploadAddress || `logo-${Date.now()}.${logoFileType.split('/')[1] || 'png'}`
              fileToUpload = new File([logoFileData], fileName, {
                type: logoFileType,
                lastModified: Date.now()
              })
              console.log('Recreated file from stored data for iPhone:', {
                fileName: fileToUpload.name,
                size: fileToUpload.size,
                type: fileToUpload.type
              })
            } catch (recreateError) {
              console.error('Failed to recreate file from stored data:', recreateError)
              // Fallback: try to get from input element
              if (logoFileInput.current?.files && logoFileInput.current.files.length > 0) {
                fileToUpload = logoFileInput.current.files[0]
                console.log('Using file from input element as fallback')
              } else {
                throw new Error('File is not accessible and cannot be retrieved')
              }
            }
          } else if (logoFileInput.current?.files && logoFileInput.current.files.length > 0) {
            // Fallback: try to get from input element
            fileToUpload = logoFileInput.current.files[0]
            console.log('Using file from input element as fallback')
          } else {
            throw new Error('File is not accessible and cannot be retrieved')
          }
        }

        const logoFormData = new FormData()
        // Append file with proper filename
        logoFormData.append('file', fileToUpload, uploadAddress)
        // Also send uploadAddress as separate field for backend to use
        logoFormData.append('uploadAddress', uploadAddress)
        logoFormData.append('chainId', chainId.toString())
        logoFormData.append('presaleAddress', presaleAddress || '')

        console.log('Uploading logo with:', {
          uploadAddress,
          presaleAddress,
          chainId,
          fileName: fileToUpload?.name,
          fileSize: fileToUpload?.size,
          fileType: fileToUpload?.type,
          isFile: fileToUpload instanceof File,
          isBlob: fileToUpload instanceof Blob
        })

        const logoResponse = await fetch(apiUrl + '/upload-logo', {
          method: 'POST',
          body: logoFormData
        })

        console.log("logo upload test------->", logoResponse.status, logoResponse.statusText)

        if (!logoResponse.ok) {
          const errorText = await logoResponse.text().catch(() => 'Unknown error')
          console.error('Logo upload failed:', logoResponse.status, logoResponse.statusText, errorText)
          toast.error('Token created successfully but logo upload failed. You can upload the logo later.')
        } else {
          const responseData = await logoResponse.json().catch(() => ({}))
          console.log('Logo uploaded successfully:', responseData)
          toast.success('Token and logo uploaded successfully!')
        }
      } catch (logoError) {
        console.error('Error uploading logo:', logoError)
        toast.error('Token created successfully but logo upload failed. You can upload the logo later.')
        // Don't throw - continue with success flow
      }


      console.log('debug------->useFlazepadSocial', useFlazepadSocial)
      // Send Telegram notification to group if Use Flazepad Social is enabled
      if (useFlazepadSocial && presaleAddress) {
        try {
          const TELEGRAM_BOT_TOKEN = '8554105441:AAGVjNbT0CnHwizTWyWydhw8XdhhYpRqHjw'
          const TELEGRAM_CHAT_ID = '-1003233171057'

          // Get chain name and explorer link
          const chainName = chainId === 56 ? 'BSC' : chainId === 97 ? 'BSC Testnet' : `Chain ${chainId}`
          const scanLink = scanLinks[chainId] || 'https://bscscan.com/'
          const contractLink = `${scanLink}address/${presaleAddress}`
          const buyLink = `${window.location.origin}/buy/?chain=${chainId}&address=${presaleAddress}`

          // Format the message (plain text format that works with the API)
          let message = `🚀 New Token Launched on FlazePad!\n\n`
          message += `Token Name: ${tokenName}\n`
          message += `Ticker: ${tokenSymbol}\n`
          message += `Chain: ${chainName}\n`
          message += `Contract Address: ${presaleAddress}\n\n`
          message += `Description:\n${tokenDescription.length > 200 ? tokenDescription.substring(0, 200) + '...' : tokenDescription}\n\n`
          message += `View on FlazePad: ${buyLink}\n`
          message += `View on Explorer: ${contractLink}\n\n`

          if (website) {
            message += `Website: ${website}\n`
          }
          if (twitter) {
            message += `Twitter: ${twitter}\n`
          }
          if (telegram) {
            message += `Telegram: ${telegram}\n`
          }

          message += `\n#FlazePad #${tokenSymbol} #${chainName}`

          // Use the same format as the working URL: POST with form data or URL-encoded
          const telegramApiUrl = `https://api.telegram.org/bot${TELEGRAM_BOT_TOKEN}/sendMessage`

          console.log('Sending Telegram notification...', {
            chat_id: TELEGRAM_CHAT_ID,
            message_length: message.length,
            tokenName,
            tokenSymbol,
            presaleAddress
          })

          // Use URLSearchParams to match the working format
          const formData = new URLSearchParams()
          formData.append('chat_id', TELEGRAM_CHAT_ID)
          formData.append('text', message)
          formData.append('parse_mode', 'HTML')
          formData.append('disable_web_page_preview', 'false')

          const telegramResponse = await fetch(telegramApiUrl, {
            method: 'POST',
            headers: {
              'Content-Type': 'application/x-www-form-urlencoded'
            },
            body: formData.toString()
          })

          const telegramData = await telegramResponse.json()

          console.log('Telegram API Response:', telegramData)

          if (!telegramResponse.ok || !telegramData.ok) {
            console.error('Failed to send Telegram notification:', telegramData)

            // Try with plain text (no HTML) as fallback
            console.log('Trying plain text format...')
            const formDataPlain = new URLSearchParams()
            formDataPlain.append('chat_id', TELEGRAM_CHAT_ID)
            formDataPlain.append('text', message)

            const retryResponse = await fetch(telegramApiUrl, {
              method: 'POST',
              headers: {
                'Content-Type': 'application/x-www-form-urlencoded'
              },
              body: formDataPlain.toString()
            })

            const retryData = await retryResponse.json()
            console.log('Plain text Telegram API Response:', retryData)

            if (!retryResponse.ok || !retryData.ok) {
              toast.error(`Token created but Telegram notification failed: ${retryData.description || telegramData.description || 'Unknown error'}`)
            } else {
              toast.success('Token created and notification sent to Telegram group!')
            }
          } else {
            console.log('Telegram notification sent successfully')
            toast.success('Token created and notification sent to Telegram group!')
          }
        } catch (telegramError) {
          console.error('Error sending Telegram notification:', telegramError)
          toast.error('Token created but failed to send Telegram notification')
          // Don't fail the entire token creation if Telegram posting fails
        }
      }

      // Update dev wallet to contract address if Use Privacy Wallet is enabled
      // if (usePrivacyWallet && presaleAddress) {
      //   try {
      //     // Get current data from the factory contract to maintain previous values
      //     const currentFeeAmount = await readContract(config, {
      //       address: getFactoryAddress(chainId),
      //       abi: FunFactoryAbi,
      //       functionName: 'feeAmount',
      //       chainId: chainId
      //     })

      //     const currentMainFee = await readContract(config, {
      //       address: getFactoryAddress(chainId),
      //       abi: FunFactoryAbi,
      //       functionName: 'mainFee',
      //       chainId: chainId
      //     })

      //     const currentMarketCap = await readContract(config, {
      //       address: getFactoryAddress(chainId),
      //       abi: FunFactoryAbi,
      //       functionName: 'marketCap',
      //       chainId: chainId
      //     })

      //     // Get all featuredTime values (array of 4)
      //     const featuredTimeArray = []
      //     for (let i = 0; i < 4; i++) {
      //       const timeValue = await readContract(config, {
      //         address: getFactoryAddress(chainId),
      //         abi: FunFactoryAbi,
      //         functionName: 'featuredTime',
      //         args: [i],
      //         chainId: chainId
      //       })
      //       featuredTimeArray.push(timeValue)
      //     }

      //     // Call updateDatas on the presale contract (presaleAddress) with contract address as _newDev
      //     // Maintain all other previous data from factory
      //     const updateTx = await writeContract(config, {
      //       address: presaleAddress,  // Call on the presale contract, not factory
      //       abi: FunFactoryAbi,       // Use FunFactoryAbi as the presale contract may have same interface
      //       functionName: 'updateDatas',
      //       args: [
      //         currentFeeAmount,      // _newFee: keep current fee amount
      //         currentMainFee,        // _mainFee: keep current main fee
      //         currentMarketCap,      // _marketCap: keep current market cap
      //         presaleAddress,        // _newDev: set to contract address (presaleAddress)
      //         featuredTimeArray      // _featuredTime: keep current featured times
      //       ],
      //       chainId: chainId
      //     })

      //     await waitForTransaction(config, {
      //       hash: updateTx
      //     })

      //     console.log('Privacy wallet updated successfully')
      //   } catch (updateError) {
      //     console.error('Error updating privacy wallet:', updateError)
      //     toast.error('Token created but failed to update privacy wallet')
      //     // Don't fail the entire token creation if privacy wallet update fails
      //   }
      // }

      // Validate presaleAddress before redirecting
      if (!presaleAddress) {
        toast.error('Failed to get presale address. Token may not have been created. Please check and try again.')
        setCreating(false)
        return
      }

      toast.success(`Successfully ${tokenName} Meme Launch created`)
      const link = `/buy/?chain=${chainId}&address=${presaleAddress}`
      window.location.href = link
    } catch (err: any) {
      console.error('Token creation error:', err)

      // Always set creating to false first
      setCreating(false)

      // Check if token was actually created (presaleAddress exists)
      // If presaleAddress exists, token was created successfully, so don't show error
      if (presaleAddress) {
        // Token was created successfully, but something else failed (like logo upload)
        // Logo upload is already handled with its own try-catch, so this is likely a different issue
        console.log('Token was created successfully, redirecting despite error:', err?.message || err)
        toast.success(`Token ${tokenName} created successfully!`)
        const link = `/buy/?chain=${chainId}&address=${presaleAddress}`
        window.location.href = link
      } else {
        // Token creation actually failed
        const errorMessage = err?.message || err?.toString() || 'Unknown error'
        console.error('Token creation failed:', errorMessage)

        // Show user-friendly error message via toast, not full-screen error
        if (errorMessage.includes('User rejected') || errorMessage.includes('User denied') || errorMessage.includes('User cancelled')) {
          toast.error('Transaction was cancelled. Please try again when ready.')
        } else if (errorMessage.includes('insufficient funds') || errorMessage.includes('Insufficient')) {
          toast.error('Insufficient funds. Please ensure you have enough BNB to cover the fees.')
        } else if (errorMessage.includes('presaleAddress')) {
          toast.error('Failed to create token. Please check your inputs and try again.')
        } else {
          // Truncate long error messages
          const shortMessage = errorMessage.length > 100 ? errorMessage.substring(0, 100) + '...' : errorMessage
          toast.error(`Failed to create token: ${shortMessage}`)
        }
      }
    }
  }

  const [, setImageLogoFile] = useState(null)

  const handleImageLogoChange = file => {
    setImageLogoFile(file)
  }

  const LogoImageUpload = ({ onChange, className, style }) => {
    const handleLogoImageChange = async (e: React.ChangeEvent<HTMLInputElement>) => {
      const selectedFile = e.target.files?.[0]
      if (selectedFile) {
        // Validate file type - support all image formats (jpeg, png, gif, webp, bmp, heic, etc.)
        if (!selectedFile.type.startsWith('image/')) {
          toast.error('Please select a valid image file (JPEG, PNG, GIF, WebP, BMP, etc.)')
          return
        }
        // Validate file size (max 10MB before compression)
        if (selectedFile.size > 10 * 1024 * 1024) {
          toast.error('Image size must be less than 10MB')
          return
        }

        try {
          // Use browser-image-compression - compresses to max 70KB for upload
          const compressionOptions = {
            maxSizeMB: 0.07, // 70KB max
            maxWidthOrHeight: 800,
            useWebWorker: false, // Avoid memory issues on iOS
            fileType: 'image/jpeg',
            initialQuality: 0.7,
            alwaysKeepResolution: false
          }

          const processedFile = await imageCompression(selectedFile, compressionOptions)

          if (processedFile.size < selectedFile.size) {
            const origKb = selectedFile.size > 1024 * 1024
              ? `${(selectedFile.size / 1024 / 1024).toFixed(1)}MB`
              : `${(selectedFile.size / 1024).toFixed(0)}KB`
            // toast.success(`Image compressed: ${origKb} → ${(processedFile.size / 1024).toFixed(0)}KB (max 70KB)`)
          }

          const fileBlob = processedFile

          console.log('File processed for upload:', {
            originalName: selectedFile.name,
            processedName: processedFile.name,
            originalSize: selectedFile.size,
            processedSize: processedFile.size,
            type: processedFile.type,
            isFile: processedFile instanceof File
          })

          // Store file data for iPhone compatibility
          setLogoFileData(fileBlob)
          setLogoFileType(processedFile.type)
          setLogoFileName(processedFile.name)
          setLogoFile(processedFile)
          setLogoPreview(URL.createObjectURL(processedFile))
          onChange(processedFile)
        } catch (error) {
          console.error('Error processing file for iPhone:', error)
          toast.error('Failed to process image. Please try selecting the image again.')
          // Fallback: try to use original file anyway
          setLogoFile(selectedFile)
          setLogoPreview(URL.createObjectURL(selectedFile))
          onChange(selectedFile)
        }
      }
    }
    const onButtonClick = (e: React.MouseEvent | React.TouchEvent) => {
      e.preventDefault()
      e.stopPropagation()
      if (logoFileInput.current) {
        logoFileInput.current.click()
      }
    }
    return (
      <div className="w-full relative" style={{ position: 'relative', width: '100%', height: '100%', minHeight: style?.minHeight || '160px' }}>
        <input
          type="file"
          ref={logoFileInput}
          accept="image/*"
          onChange={handleLogoImageChange}
          className="hidden"
          style={{
            position: 'absolute',
            width: '1px',
            height: '1px',
            opacity: 0,
            overflow: 'hidden',
            zIndex: -1
          }}
          // Mobile-friendly attributes
          multiple={false}
        />
        <div
          onClick={onButtonClick}
          onTouchStart={(e) => {
            // Handle touch events for mobile
            // Don't prevent default to allow native file picker
            if (logoFileInput.current) {
              // Small delay to ensure touch is registered
              setTimeout(() => {
                logoFileInput.current?.click()
              }, 0)
            }
          }}
          style={{
            touchAction: 'manipulation',
            WebkitTapHighlightColor: 'transparent',
            cursor: 'pointer',
            width: '100%',
            height: '100%',
            minHeight: '100%',
            display: 'flex',
            alignItems: 'stretch'
          }}
        >
          <BannerUploadBox
            handleClick={(e) => {
              // Ensure click works on both desktop and mobile
              e?.preventDefault?.()
              e?.stopPropagation?.()
              if (logoFileInput.current) {
                logoFileInput.current.click()
              }
            }}
            preview={logoPreview}
            onClear={(e) => {
              e?.stopPropagation()
              setLogoFile(null)
              setLogoPreview(null)
              setLogoFileData(null)
              setLogoFileType(null)
              setLogoFileName(null)
              if (logoFileInput.current) {
                logoFileInput.current.value = ''
              }
            }}
            className={'cursor-pointer w-full h-full'}
            style={{ ...style, width: '100%', height: '100%' }}
          />
        </div>
      </div>
    )
  }

  const setMaxWalletAmount = value => {
    setMaxWallet(value)
  }

  const changeChain = value => {
    setChainId(value)
    const routers = getRouterAddress(value)
    setRouters(routers)
  }

  const setRouterAddress = value => {
    setRouter(value)
  }

  return (
    <div className="flex flex-col min-h-screen" style={{ background: 'var(--page-bg)' }}>
      <div className="flex-grow">
        <TopBar />
        <div className="max-w-7xl mx-auto pt-28 pb-16 px-4 sm:px-6">
          <section
            className="p-6 rounded-xl"
            style={{
              background: 'var(--card-bg)',
              border: '2px solid transparent',
              backgroundImage:
                'linear-gradient(var(--card-bg), var(--card-bg)), var(--card-border)',
              backgroundOrigin: 'border-box',
              backgroundClip: 'padding-box, border-box',
              boxShadow: 'var(--shadow)'
            }}
          >
            {/* Header */}
            <div
              className="border-b pb-6 mb-8 text-center"
              style={{ borderColor: 'var(--border-color)' }}
            >
              <h1
                className="text-2xl sm:text-3xl font-bold"
                style={{ color: 'var(--text-primary)' }}
              >
                Create Token
              </h1>
              {/* <p className="mt-2" style={{ color: 'var(--text-secondary)' }}>
                Note: data CANNOT be changed after creation
              </p> */}
            </div>

            <div className="flex flex-col gap-8">
              {/* General Information Section */}
              <div>
                <h2
                  className="text-2xl font-bold mb-6"
                  style={{ color: 'var(--text-primary)' }}
                >
                  General Information
                </h2>

                <div className="flex flex-col gap-6">
                  {/* First Line: Upload Logo (left, 1/4 width) and Token Name + Ticker (right, 3/4 width) */}
                  <div className="flex flex-col md:flex-row gap-6">
                    {/* Upload Logo - Full width on mobile, 1/4 width on desktop */}
                    <div className="flex-shrink-0 flex flex-col w-full md:w-1/4">
                      <label
                        className="block text-sm font-medium mb-2"
                        style={{ color: 'var(--text-secondary)' }}
                      >
                        Upload Logo{' '}
                        <span style={{ color: 'var(--text-accent)' }}>*</span>
                      </label>
                      <div
                        className="p-4 rounded-xl flex-1"
                        style={{
                          background: 'var(--input-bg)',
                          border: '1px solid var(--input-border)',
                          display: 'flex',
                          alignItems: 'center',
                          justifyContent: 'center'
                        }}
                      >
                        <div style={{ padding: '8px', width: '100%', boxSizing: 'border-box', minHeight: '180px', display: 'flex', alignItems: 'stretch' }}>
                          <LogoImageUpload
                            onChange={handleImageLogoChange}
                            className="cursor-pointer w-full h-full"
                            style={{ minHeight: '160px', width: '100%', height: '100%' }}
                          />
                        </div>
                      </div>
                    </div>

                    {/* Token Name and Ticker - Full width on mobile, 3/4 width on desktop, stacked vertically */}
                    <div className="flex-1 flex flex-col gap-6 w-full md:w-3/4">
                      {/* Token Name */}
                      <div>
                        <label
                          className="block text-sm font-medium mb-2"
                          style={{ color: 'var(--text-secondary)' }}
                        >
                          Token Name{' '}
                          <span style={{ color: 'var(--text-accent)' }}>*</span>
                        </label>
                        <div
                          className="p-4 rounded-xl"
                          style={{
                            background: 'var(--input-bg)',
                            border: '1px solid var(--input-border)'
                          }}
                        >
                          <Input
                            placeholder="Enter the token name"
                            type="text"
                            changeValue={setTokenName}
                            value={tokenName}
                          />
                        </div>
                      </div>

                      {/* Ticker Name */}
                      <div>
                        <label
                          className="block text-sm font-medium mb-2"
                          style={{ color: 'var(--text-secondary)' }}
                        >
                          Ticker Name{' '}
                          <span style={{ color: 'var(--text-accent)' }}>*</span>
                        </label>
                        <div
                          className="p-4 rounded-xl"
                          style={{
                            background: 'var(--input-bg)',
                            border: '1px solid var(--input-border)'
                          }}
                        >
                          <Input
                            placeholder="Enter the ticker name"
                            type="text"
                            changeValue={setTokenSymbol}
                            value={tokenSymbol}
                          />
                        </div>
                      </div>
                    </div>
                  </div>

                  {/* Fourth Line: Token Description */}
                  <div>
                    <label
                      className="block text-sm font-medium mb-2"
                      style={{ color: 'var(--text-secondary)' }}
                    >
                      Token Description (Max 1000 characters){' '}
                      <span style={{ color: 'var(--text-accent)' }}>*</span>
                    </label>
                    <div
                      className="p-4 rounded-xl"
                      style={{
                        background: 'var(--input-bg)',
                        border: '1px solid var(--input-border)'
                      }}
                    >
                      <TextArea
                        rows={4}
                        placeholder="Enter the description"
                        changeValue={setTokenDescription}
                        value={tokenDescription}
                      />
                    </div>
                  </div>
                </div>
              </div>

              {/* Features Section */}
              <div>
                <h2
                  className="text-2xl font-bold mb-6"
                  style={{ color: 'var(--text-primary)' }}
                >
                  Features
                </h2>

                <div className="flex flex-col gap-6">
                  {/* Use Privacy Wallet */}
                  <div>
                    <div className="flex items-center gap-3">
                      <button
                        type="button"
                        onClick={() => setUsePrivacyWallet(!usePrivacyWallet)}
                        className={`relative inline-flex h-6 w-11 flex-shrink-0 items-center rounded-full transition-colors ${usePrivacyWallet ? 'bg-[var(--nav-button-active-bg)]' : 'bg-gray-300'
                          }`}
                        style={{
                          background: usePrivacyWallet
                            ? 'var(--nav-button-active-bg)'
                            : 'var(--button-disabled-bg)'
                        }}
                      >
                        <span
                          className={`inline-block h-4 w-4 transform rounded-full bg-white transition-transform ${usePrivacyWallet ? 'translate-x-6' : 'translate-x-1'
                            }`}
                        />
                      </button>
                      <span className="text-xl font-medium" style={{ color: 'var(--text-secondary)' }}>
                        Use Privacy Wallet
                      </span>
                      <a id="privacy-wallet-tooltip" className="cursor-pointer">
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          fill="none"
                          viewBox="0 0 24 24"
                          stroke="currentColor"
                          className="w-4 h-4"
                          style={{ color: 'var(--text-secondary)' }}
                        >
                          <path
                            strokeLinecap="round"
                            strokeLinejoin="round"
                            strokeWidth={2}
                            d="M13 16h-1v-4h-1m1-4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z"
                          />
                        </svg>
                        <Tooltip
                          anchorSelect="#privacy-wallet-tooltip"
                          className="z-50 max-w-xs p-3 rounded-lg shadow-lg"
                          style={{
                            background: 'var(--card-bg)',
                            color: 'var(--text-primary)',
                            border: '1px solid var(--input-border)'
                          }}
                          content="When enabled, your wallet address will be kept private during token creation. This feature helps protect your identity and transaction privacy while participating in the launchpad."
                        />
                      </a>
                    </div>
                    <p className="text-xl mt-1.5 ml-14" style={{ color: 'var(--text-secondary)', opacity: 0.85 }}>
                      When enabled as 0.01BNB fee, your wallet address will be kept private during token creation.
                    </p>
                    {usePrivacyWallet && (
                      <div className="mt-4 ml-14">
                        <label
                          className="block text-sm font-medium mb-2"
                          style={{ color: 'var(--text-secondary)' }}
                        >
                          Privacy fee recipient address <span style={{ color: 'var(--text-accent)' }}>*</span>
                        </label>
                        <div
                          className="p-4 rounded-xl"
                          style={{
                            background: 'var(--input-bg)',
                            border: '1px solid var(--input-border)'
                          }}
                        >
                          <Input
                            placeholder="0x..."
                            type="text"
                            changeValue={setPrivacyFeeRecipient}
                            value={privacyFeeRecipient}
                          />
                        </div>
                      </div>
                    )}
                  </div>

                  {/* Second Line: Use Flazepad Social Toggle */}
                  <div>
                    <div className="flex items-center gap-3">
                      <button
                        type="button"
                        onClick={() => setUseFlazepadSocial(!useFlazepadSocial)}
                        className={`relative inline-flex h-6 w-11 flex-shrink-0 items-center rounded-full transition-colors ${useFlazepadSocial ? 'bg-[var(--nav-button-active-bg)]' : 'bg-gray-300'
                          }`}
                        style={{
                          background: useFlazepadSocial
                            ? 'var(--nav-button-active-bg)'
                            : 'var(--button-disabled-bg)'
                        }}
                      >
                        <span
                          className={`inline-block h-4 w-4 transform rounded-full bg-white transition-transform ${useFlazepadSocial ? 'translate-x-6' : 'translate-x-1'
                            }`}
                        />
                      </button>
                      <span className="text-xl font-medium" style={{ color: 'var(--text-secondary)' }}>
                        Use FlazePad Social
                      </span>
                      <a id="flazepad-social-tooltip" className="cursor-pointer">
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          fill="none"
                          viewBox="0 0 24 24"
                          stroke="currentColor"
                          className="w-4 h-4"
                          style={{ color: 'var(--text-secondary)' }}
                        >
                          <path
                            strokeLinecap="round"
                            strokeLinejoin="round"
                            strokeWidth={2}
                            d="M13 16h-1v-4h-1m1-4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z"
                          />
                        </svg>
                        <Tooltip
                          anchorSelect="#flazepad-social-tooltip"
                          className="z-50 max-w-xs p-3 rounded-lg shadow-lg"
                          style={{
                            background: 'var(--card-bg)',
                            color: 'var(--text-primary)',
                            border: '1px solid var(--input-border)'
                          }}
                          content="When enabled, your new token will be automatically announced in the FlazePad Telegram group (https://t.me/FlazePad) with all token details including name, ticker, contract address, and links. This helps promote your token to the community."
                        />
                      </a>
                    </div>
                    <p className="text-xl mt-1.5 ml-14" style={{ color: 'var(--text-secondary)', opacity: 0.85 }}>
                      When enabled as 0.01BNB fee, your new token will be automatically announced in the FlazePad Telegram group with all token details.
                    </p>
                  </div>

                  {/* Third Line: Max Wallet */}
                  {/* <div>
                  <label
                    className="block text-sm font-medium mb-2"
                    style={{ color: 'var(--text-secondary)' }}
                  >
                    Max Wallet (%){' '}
                    <span style={{ color: 'var(--text-accent)' }}>*</span>
                  </label>
                  <div
                    className="p-4 rounded-xl"
                    style={{
                      background: 'var(--input-bg)',
                      border: '1px solid var(--input-border)'
                    }}
                  >
                    <div className="flex gap-2">
                      {[1, 2].map(percent => (
                        <button
                          key={percent}
                          className={`flex-1 py-2 rounded-lg transition-colors ${maxWallet === percent
                              ? 'bg-[var(--nav-button-active-bg)] text-[var(--nav-button-active-text)]'
                              : 'bg-[var(--nav-button-inactive-bg)] text-[var(--nav-button-inactive-text)]'
                            }`}
                          onClick={() => setMaxWalletAmount(percent)}
                          style={{
                            border: '1px solid var(--input-border)'
                          }}
                        >
                          {percent}%
                        </button>
                      ))}
                    </div>
                  </div>
                  </div> */}

                  {/* Fourth Line: Pre-launch buy (enabled for both normal and privacy wallet) */}
                  <div>
                    <label
                      className="block text-2xl font-bold mb-2 flex items-center"
                      style={{ color: 'var(--text-secondary)' }}
                    >
                      Pre-Launch Buy ({coinNames[chainIdNumber]})
                      <a id="snipe-tooltip" className="ml-1 cursor-pointer">
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          fill="none"
                          viewBox="0 0 24 24"
                          stroke="currentColor"
                          className="w-4 h-4"
                          style={{ color: 'var(--text-secondary)' }}
                        >
                          <path
                            strokeLinecap="round"
                            strokeLinejoin="round"
                            strokeWidth={2}
                            d="M13 16h-1v-4h-1m1-4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z"
                          />
                        </svg>
                        <Tooltip
                          anchorSelect="#snipe-tooltip"
                          className="z-50 max-w-xs p-3 rounded-lg shadow-lg"
                          style={{
                            background: 'var(--card-bg)',
                            color: 'var(--text-primary)',
                            border: '1px solid var(--input-border)'
                          }}
                          content="This is where you input how much you want to buy at launch. Bundling means automatically buying tokens with your dev wallet in the same txhash as the token deployment. This feature guarantees you will be the first buyer of your own token."
                        />
                      </a>
                    </label>
                    <div
                      className="p-4 rounded-xl"
                      style={{
                        background: 'var(--input-bg)',
                        border: '1px solid var(--input-border)'
                      }}
                    >
                      <Input
                        placeholder="Enter Amount"
                        type="number"
                        changeValue={setDepositAmount}
                        value={depositAmount}
                      />
                    </div>
                  </div>

                  {/* Last Line: Show More Options Dropdown */}
                  <div>
                    <button
                      type="button"
                      onClick={() => setShowMoreOptions(!showMoreOptions)}
                      className="w-full flex items-center justify-between p-4 rounded-xl transition-colors"
                      style={{
                        background: 'var(--input-bg)',
                        border: '1px solid var(--input-border)',
                        color: 'var(--text-primary)'
                      }}
                    >
                      <span className="text-sm font-medium">
                        {showMoreOptions ? 'Hide more options' : 'Show more options'}
                      </span>
                      <svg
                        className={`w-5 h-5 transform transition-transform ${showMoreOptions ? 'rotate-180' : ''
                          }`}
                        fill="none"
                        stroke="currentColor"
                        viewBox="0 0 24 24"
                      >
                        <path
                          strokeLinecap="round"
                          strokeLinejoin="round"
                          strokeWidth={2}
                          d="M19 9l-7 7-7-7"
                        />
                      </svg>
                    </button>
                  </div>
                </div>
              </div>

              {/* Optional Sections */}
              {showMoreOptions && (
                <div className="flex flex-col gap-6">
                  <h2
                    className="text-xl font-bold"
                    style={{ color: 'var(--text-primary)' }}
                  >
                    Social Links
                  </h2>

                  {/* Telegram */}
                  <div>
                    <label
                      className="block text-sm font-medium mb-2"
                      style={{ color: 'var(--text-secondary)' }}
                    >
                      Telegram Link
                    </label>
                    <div
                      className="p-4 rounded-xl"
                      style={{
                        background: 'var(--input-bg)',
                        border: '1px solid var(--input-border)'
                      }}
                    >
                      <Input
                        placeholder="Enter the telegram URL"
                        type="text"
                        changeValue={setTelegram}
                        value={telegram}
                      />
                    </div>
                  </div>

                  {/* Twitter */}
                  <div>
                    <label
                      className="block text-sm font-medium mb-2"
                      style={{ color: 'var(--text-secondary)' }}
                    >
                      X Link
                    </label>
                    <div
                      className="p-4 rounded-xl"
                      style={{
                        background: 'var(--input-bg)',
                        border: '1px solid var(--input-border)'
                      }}
                    >
                      <Input
                        placeholder="Enter the X URL"
                        type="text"
                        changeValue={setTwitter}
                        value={twitter}
                      />
                    </div>
                  </div>

                  {/* Website */}
                  <div>
                    <label
                      className="block text-sm font-medium mb-2"
                      style={{ color: 'var(--text-secondary)' }}
                    >
                      Website
                    </label>
                    <div
                      className="p-4 rounded-xl"
                      style={{
                        background: 'var(--input-bg)',
                        border: '1px solid var(--input-border)'
                      }}
                    >
                      <Input
                        placeholder="Enter the website URL"
                        type="text"
                        changeValue={setWebsite}
                        value={website}
                      />
                    </div>
                  </div>

                  {/* <h2
                        className="text-xl font-bold"
                        style={{ color: 'var(--text-primary)' }}
                      >
                        DEX
                  </h2> */}

                  {/* Network Selector */}
                  {/* <div>
                        <label
                          className="block text-sm font-medium mb-2"
                          style={{ color: 'var(--text-secondary)' }}
                        >
                          Network
                        </label>
                        <div
                          className="p-4 rounded-xl"
                          style={{
                            background: 'var(--input-bg)',
                            border: '1px solid var(--input-border)'
                          }}
                        >
                          <div className="flex flex-wrap gap-2">
                            {supportedChainIds.map(id => (
                              <button
                                key={id}
                                className={`p-2 rounded-lg transition-all ${chainIdNumber === id
                                    ? 'ring-2 ring-blue-500'
                                    : 'opacity-70 hover:opacity-100'
                                  }`}
                                onClick={() => changeChain(id)}
                                style={{
                                  background: 'var(--card-bg)',
                                  border: '1px solid var(--input-border)'
                                }}
                              >
                                <img
                                  src={chainLogos[id]}
                                  alt={`Chain ${id}`}
                                  className="w-8 h-8"
                                />
                              </button>
                            ))}
                          </div>
                        </div>
                  </div> */}

                  {/* DEX Selector */}
                  {/* <div>
                        <label
                          className="block text-sm font-medium mb-2"
                          style={{ color: 'var(--text-secondary)' }}
                        >
                          Dex
                        </label>
                        <div
                          className="p-4 rounded-xl"
                          style={{
                            background: 'var(--input-bg)',
                            border: '1px solid var(--input-border)'
                          }}
                        >
                          <div className="flex flex-wrap gap-2">
                            {Object.entries(routers).map(([key, value]) => (
                              <button
                                key={key}
                                className={`px-4 py-2 rounded-lg transition-colors ${routerAddr === value
                                    ? 'bg-gradient-to-r from-blue-500 to-cyan-500 text-white'
                                    : 'bg-transparent'
                                  }`}
                                onClick={() => setRouterAddress(value)}
                                style={{
                                  border: '1px solid var(--input-border)',
                                  color:
                                    routerAddr === value
                                      ? 'white'
                                      : 'var(--text-secondary)'
                                }}
                              >
                                {key}
                              </button>
                            ))}
                          </div>
                        </div>
                  </div> */}
                </div>
              )}

              {/* Create Coin Button */}
              <div className="mt-8">
                <button
                  disabled={
                    !address ||
                    tokenName === '' ||
                    tokenSymbol === '' ||
                    tokenDescription === '' ||
                    creating ||
                    !logoFile ||
                    (usePrivacyWallet && (!privacyFeeRecipient.trim() || !/^0x[a-fA-F0-9]{40}$/.test(privacyFeeRecipient.trim()))) ||
                    (() => {
                      const baseFee = usePrivacyWallet && useFlazepadSocial ? 0.03 : (usePrivacyWallet || useFlazepadSocial) ? 0.02 : 0.01
                      const totalRequired = baseFee + (Number(depositAmount) || 0)
                      return totalRequired > accountBalance
                    })()
                  }
                  onClick={onPumpItUpCreate}
                  className="w-full px-8 py-4 rounded-lg font-bold transition-all shadow-lg hover:shadow-xl disabled:opacity-50 disabled:cursor-not-allowed"
                  style={{
                    background: 'var(--primary-gradient)',
                    color: 'var(--button-text)'
                  }}
                >
                  {creating ? (
                    <ClipLoader
                      color="var(--button-text)"
                      loading={true}
                      size={24}
                    />
                  ) : (
                    'Create Token'
                  )}
                </button>
              </div>
            </div>
          </section>
        </div>
      </div>
      <Footer />
    </div>
  )
}

export default App

